import { render, staticRenderFns } from "./BodyBase.vue?vue&type=template&id=6da0edb3&"
import script from "./BodyBase.vue?vue&type=script&lang=js&"
export * from "./BodyBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports